//
//  ghaCsv.ts
//
//  isana.net,inc. Proprietary and Confidential

import { CsvSummaryGroup, CsvSummaryItem } from "./csv";

// GHA 日次サマリー項目 (API の GhaCsvSummary.ts と同期すること)
const ghaSleepItems: CsvSummaryItem[] = [
  { type: "bed_time", label: "ベッドにいる時間" },
  { type: "sleep_time", label: "睡眠時間" },
  { type: "sleep_start", label: "睡眠開始時間" },
  { type: "sleep_end", label: "睡眠終了時間" },
  { type: "awake_time", label: "覚醒時間(分)" },
  { type: "rem_sleep", label: "レム睡眠時間(分)" },
  { type: "light_sleep", label: "浅い睡眠時間(分)" },
  { type: "deep_sleep", label: "深い睡眠時間(分)" },
  { type: "avg_awake_time", label: "覚醒時間の平均" },
  { type: "avg_rem_sleep", label: "レム睡眠時間の平均" },
  { type: "avg_light_sleep", label: "浅い睡眠時間の平均" },
  { type: "avg_deep_sleep", label: "深い睡眠時間の平均" },
  { type: "sleep_efficiency", label: "睡眠効率" },
  { type: "minutes_until_rem", label: "レム睡眠に入るまでの時間(分)" },
  { type: "minutes_until_deep", label: "深い睡眠に入るまでの時間(分)" },
  { type: "minutes_until_light", label: "浅い睡眠に入るまでの時間(分)" },
  { type: "awake_count", label: "覚醒回数(回)" },
  { type: "spo2_avg", label: "睡眠時のSpO2(平均)" },
  { type: "spo2_min", label: "睡眠時のSpO2(最小)" },
  { type: "spo2_max", label: "睡眠時のSpO2(最大)" },
  { type: "skin_temp", label: "睡眠中の皮膚体温(℃)" },
];

const ghaRespirationItems: CsvSummaryItem[] = [
  { type: "avg_respiration", label: "睡眠時の平均呼吸数(回/分)" },
  { type: "light_sleep_respiration", label: "浅い睡眠時の平均呼吸数" },
  { type: "rem_sleep_respiration", label: "レム睡眠時の平均呼吸数" },
  { type: "deep_sleep_respiration", label: "深い睡眠時の平均呼吸数" },
];

const ghaBodyItems: CsvSummaryItem[] = [
  { type: "wear_rate", label: "着用率" },
  { type: "weight_kg", label: "体重(kg)" },
  { type: "body_fat_percentage", label: "体脂肪率(%)" },
];

const ghaNutritionItems: CsvSummaryItem[] = [
  { type: "nutrition_calories", label: "摂取カロリー(kcal)" },
  { type: "nutrition_protein", label: "たんぱく質(g)" },
  { type: "nutrition_fat", label: "脂質(g)" },
  { type: "nutrition_carbohydrates", label: "炭水化物(g)" },
  { type: "nutrition_sodium", label: "ナトリウム(mg)" },
];

const ghaHydrationItems: CsvSummaryItem[] = [
  { type: "hydration_ml", label: "水分摂取量(mL)" },
];

const ghaHeartRateItems: CsvSummaryItem[] = [
  { type: "resting_hr", label: "安静時心拍数" },
  { type: "daily_rmssd", label: "心拍数変動(RMSSD)" },
  { type: "deep_rmssd", label: "深い睡眠時の心拍数変動(RMSSD)" },
];

const ghaActivityItems: CsvSummaryItem[] = [
  { type: "steps", label: "1日の合計歩数" },
  { type: "distance", label: "1日の合計移動距離" },
  { type: "floors", label: "1日の合計階数" },
  { type: "sitting_time", label: "1日の座っている時間(分)" },
  { type: "lightly_active_time", label: "1日の軽く活動的だった時間(分)" },
  { type: "moderately_active_time", label: "1日のかなり活動的だった時間(分)" },
  { type: "vigorously_active_time", label: "1日の非常に活動的だった時間(分)" },
  { type: "calories_burned", label: "1日の消費カロリー(kcal)" },
  { type: "active_calories", label: "1日の活動消費カロリー(kcal)" },
];

const ghaAzmItems: CsvSummaryItem[] = [
  { type: "total_azm", label: "1日の合計AZM" },
  { type: "fat_burn_azm", label: "1日の脂肪燃焼心拍ゾーンのAZM" },
  { type: "cardio_azm", label: "1日の有酸素運動心拍ゾーンのAZM" },
  { type: "peak_azm", label: "1日のピーク心拍ゾーンのAZM" },
];

const ghaVo2MaxItems: CsvSummaryItem[] = [
  { type: "vo2_max_estimate", label: "VO2Max推定値" },
  { type: "vo2_max_std_dev", label: "VO2Max標準偏差" },
];

const ghaHrZoneTimeItems: CsvSummaryItem[] = [
  { type: "hr_out_of_range_minutes", label: "範囲外ゾーンの時間(分)" },
  { type: "hr_light_minutes", label: "軽い活動ゾーンの時間(分)" },
  { type: "hr_moderate_minutes", label: "有酸素運動ゾーンの時間(分)" },
  { type: "hr_vigorous_minutes", label: "激しい運動ゾーンの時間(分)" },
  { type: "hr_peak_minutes", label: "ピーク運動ゾーンの時間(分)" },
];

const ghaHrZoneCalorieItems: CsvSummaryItem[] = [
  { type: "hr_zone_light_kcal", label: "軽い活動ゾーンの消費カロリー(kcal)" },
  {
    type: "hr_zone_moderate_kcal",
    label: "有酸素運動ゾーンの消費カロリー(kcal)",
  },
  {
    type: "hr_zone_vigorous_kcal",
    label: "激しい運動ゾーンの消費カロリー(kcal)",
  },
  {
    type: "hr_zone_intense_kcal",
    label: "ピーク運動ゾーンの消費カロリー(kcal)",
  },
  { type: "hr_zone_total_kcal", label: "全ゾーンの消費カロリー合計(kcal)" },
];

const ghaHrZoneBoundaryItems: CsvSummaryItem[] = [
  { type: "hr_zone_light_min", label: "軽い活動ゾーン最小心拍数" },
  { type: "hr_zone_light_max", label: "軽い活動ゾーン最大心拍数" },
  { type: "hr_zone_moderate_min", label: "有酸素運動ゾーン最小心拍数" },
  { type: "hr_zone_moderate_max", label: "有酸素運動ゾーン最大心拍数" },
  { type: "hr_zone_vigorous_min", label: "激しい運動ゾーン最小心拍数" },
  { type: "hr_zone_vigorous_max", label: "激しい運動ゾーン最大心拍数" },
  { type: "hr_zone_peak_min", label: "ピーク運動ゾーン最小心拍数" },
  { type: "hr_zone_peak_max", label: "ピーク運動ゾーン最大心拍数" },
];

export const ghaCsvSummaryGroups: CsvSummaryGroup[] = [
  { title: "睡眠", items: ghaSleepItems },
  { title: "呼吸数", items: ghaRespirationItems },
  { title: "着用率・体組成", items: ghaBodyItems },
  { title: "栄養", items: ghaNutritionItems },
  { title: "水分", items: ghaHydrationItems },
  { title: "心拍数・HRV", items: ghaHeartRateItems },
  { title: "活動量", items: ghaActivityItems },
  { title: "AZM", items: ghaAzmItems },
  { title: "VO2Max", items: ghaVo2MaxItems },
  { title: "心拍ゾーン時間", items: ghaHrZoneTimeItems },
  { title: "心拍ゾーンカロリー", items: ghaHrZoneCalorieItems },
  { title: "心拍ゾーン境界値", items: ghaHrZoneBoundaryItems },
];

export const ghaCsvSummaryItems: CsvSummaryItem[] = ghaCsvSummaryGroups.flatMap(
  (g) => g.items
);

// GHA 時系列（イントラデイ）項目
export type GhaIntradayItem = {
  type: string;
  label: string;
  description: string;
};

export const ghaIntradayItems: GhaIntradayItem[] = [
  // 取得間隔は種別・実データにより異なるため、間隔の表記は付けない（API側CSVヘッダと同方針）
  { type: "heart_rate_intraday", label: "心拍数", description: "" },
  { type: "activity_level_intraday", label: "アクティビティレベル", description: "" },
  { type: "step_intraday", label: "歩数", description: "" },
  { type: "calorie_intraday", label: "消費カロリー", description: "" },
  { type: "azm_intraday", label: "AZM", description: "" },
  { type: "hrv_intraday", label: "HRV", description: "" },
  { type: "spo2_intraday", label: "SpO2", description: "" },
  { type: "sleep_stages", label: "睡眠ステージ", description: "" },
  { type: "workouts", label: "ワークアウト", description: "" },
];
